import { cloneDeep } from 'lodash'
export const formatSpecList = (skuList, rowsData, specNum) => {
    const res = [];
    skuList.forEach((sku) => {
        const idx = rowsData.findIndex(item => item.baseItemId == sku.baseItemId);
        if (idx !== -1) {
            res.push(formatItem(sku, rowsData[idx], specNum));
        }
    })
    return res;
}
export const getSpecNum = (skuList) => {
    return skuList.reduce((acc, sku) => {
        if (sku.skuSpecifications.length > acc) {
            return sku.skuSpecifications.length;
        }
        return acc;
    }, 0);
};
const formatItem = (sku, row, specNum) => {
    const spec0 = sku.skuSpecifications[0];
    let spec1 = sku.skuSpecifications[1];
    if (specNum > 1 && !spec1) {
        spec1 = {
            isNewCreated: true,
            "checked": true,
            "name": "规格2",
            "nameKey": "规格2",
            "value": "无规格",
            "valueKey": "无规格"
        }
        sku.skuSpecifications[1] = {...spec1};
    };
    const _skuid = sku.skuSpecifications.map(s => s.valueKey).join('-');
    let item =  {
        ...sku,
        spec0: spec0.value,
        title: row.title,
        _skuid: _skuid
    }
    if (spec1 && specNum > 1) {
        item.spec1 = spec1.value;
    }
    return item;
}

export const transFormData = (formData) => {

    return {
        // categoryIds: formData.categoryIds.map(id => Number(id)),
        categoryIds: [],
        goodsName: formData.title,
        goodsDesc: formData.description,
        carouselGallery: formData.mainImages || [],
        detailGallery: formData.detailImages || [],
        marketPrice: formData.marketPrice,
        goodsSn: formData.outerId,
        goodsType: formData.goodsType || 1,
        secondHand: formData.secondHand || 0,
        isPreSale: formData.isPreSale || 0,
        shipmentLimitSecond: (formData.shipmentLimitSecond === null || formData.shipmentLimitSecond === undefined) ? (48*60*60) : formData.shipmentLimitSecond,
    }
}

export const generateSpecifications = (specList, formData) => {
    if (!specList?.length) return [];

    const specNum = getSpecNum(specList);
    // 初始化规格模板
    const mainGoods = specList.find(s => s.baseItemId === formData.baseItemId) || specList[0];
    const mainSkuSpecs = mainGoods.skuSpecifications || []
    const res = Array.from({ length: specNum }, (_, i) => ({
        name: i === 0 ? mainSkuSpecs[0]?.name || '颜色' : mainSkuSpecs[1]?.name || '尺码',
        nameKey: i === 0 ? mainSkuSpecs[0]?.nameKey || '颜色' : mainSkuSpecs[1]?.nameKey || '尺码',
        checked: true,
        values: []
    }));

    // 用 Map 去重，O(1) 查询
    const valueMap = res.map(() => new Map());

    specList.forEach(item => {
        // 处理第 0 维
        const spec0 = item.skuSpecifications[0];
        if (spec0 && !valueMap[0].has(item.spec0)) {
            valueMap[0].set(item.spec0, true);
            // res[0].name = spec0.name || res[0].name;
            // res[0].nameKey = spec0.nameKey || res[0].nameKey;
            res[0].values.push({ ...spec0, value: item.spec0, valueKey: item.spec0, name: res[0].name, nameKey: res[0].nameKey });
        }

        // 处理第 1 维
        if (specNum > 1) {
            const spec1 = item.skuSpecifications[1];
            if (spec1 && !valueMap[1].has(item.spec1)) {
                valueMap[1].set(item.spec1, true);
                // res[1].name = spec1.name || res[1].name;
                // res[1].nameKey = spec1.nameKey || res[1].nameKey;
                res[1].values.push({ ...spec1, value: item.spec1, valueKey: item.spec1, name: res[1].name, nameKey: res[1].nameKey  });
            }
        }
    });

    return res;
}
// 各平台 SKU 字段映射配置：目标字段名 -> 源字段名
const platformSkuFieldMaps = {
    fxg: { code: 'skuOuterId', outerSkuId: 'outSkuPlatform', price: 'salesPrice' },
    tb: { skuPrice: 'salesPrice' },
    pdd: { outSkuSn: 'skuOuterId', multiPrice: 'salesPrice' },
    '1688': { price: 'salesPrice' },
    kuaishou: { skuNick: 'skuOuterId', skuSalePrice: 'salesPrice' },
    jd: { outerSkuId: 'skuOuterId', jdPrice: 'salesPrice' },
    wxxd: { salePrice: 'salesPrice', stockNum: 'stock', skuCode: 'skuOuterId' },
    xhs: { erpCode: 'skuOuterId', price: 'salesPrice' },
    wxsph: { skuCode: 'skuOuterId',platformSkuCode:'outSkuPlatform', salePrice: 'salesPrice', stockNum: 'stock' },
};

// 各平台默认 SKU 模板（新增规格时使用）
const defaultSkuItemTemplates = {
    fxg: { code: '', outerSkuId: '', price: 0, stockNum: 0, weight: 0 },
    tb: { skuOuterId: '', outSkuPlatform: '', skuPrice: 0, skuStock: 0, skuFieldDescriptorList: [] },
    pdd: { outSkuSn: '', outSkuPlatform: '', multiPrice: 0, singlePrice: 0, quantity: 0, weight: 0 },
    '1688': { skuOuterId: '', skuPrice: 0, skuStock: 0, skuStockOnProcess: 0, skuFieldDescriptorList: [] },
    kuaishou: { skuNick: '', skuSalePrice: 0, skuStock: 0 },
    jd: { outerSkuId: '', jdPrice: 0, salesPrice: 0, stockNum: 0 },
    xhs: { erpCode: '', price: 0, originalPrice: 0, stock: 0 },
    wxsph: { skuCode: '', outerSkuId: '', salePrice: 0, stockNum: 0, stock: 0,platformSkuCode:'' },
};

/**
 * 按平台字段映射格式化 skuList
 * @param {string} platform
 * @param {Array} skuList
 */
function skuTableColsFormat(platform, skuList) {
    const fieldMap = platformSkuFieldMaps[platform];
    if (!fieldMap) return skuList;
    return skuList.map(item => {
        const mapped = {};
        for (const [target, src] of Object.entries(fieldMap)) {
            mapped[target] = item[src];
        }
        return { ...item, ...mapped };
    });
}

const defaultSkuItem = (source) => cloneDeep(defaultSkuItemTemplates[source]) || {};

const findSkuListItem = (list, valueKeys) => {
    const index = list.findIndex(sku => valueKeys.every((key, i) => sku[`spec${i}`] === key));
    return { index, item: index > -1 ? cloneDeep(list[index]) : null };
};

export const generateSkulist = (specifications, specList, source) => {
    const _skuList = skuTableColsFormat(source, specList);

    if (!specifications?.length) return [];
    const originalSpecList = cloneDeep(_skuList);
    const skuList = [];
    const defaultTemplate = defaultSkuItem(source);
    const baseSku = _skuList[0];

    const generateCombinations = (specs, path = []) => {
        if (!specs.length) {
            const valueKeys = path.map(item => item.valueKey);
            const skuSpecifications = path.map((item, idx) => ({
                nameKey: specifications[idx].nameKey,
                name: specifications[idx].name,
                checked: item.checked,
                value: item.value,
                valueKey: item.valueKey,
                ...(idx === 0 ? { imageUrl: item.imageUrl || '' } : {}),
            }));

            const { index, item: matchedSku } = findSkuListItem(originalSpecList, valueKeys);
            let skuItem;

            if (index > -1) {
                skuItem = { ...defaultTemplate, ...matchedSku };
                originalSpecList.splice(index, 1);
            } else {
                skuItem = {
                    // ...cloneDeep(baseSku),
                    ...defaultTemplate,
                    id: null,
                    ...(source === 'pdd' ? { skuImg: skuSpecifications[0].imageUrl } : {}),
                    disabled: true
                };
            }

            skuItem.skuSpecifications = skuSpecifications;
            if (source === 'kuaishou') {
                skuItem.skuSpecifications1 = skuSpecifications;
            }
            skuList.push(skuItem);
            return;
        }
        const [first, ...rest] = specs;
        first.values.forEach(val => generateCombinations(rest, [...path, val]));
    };

    generateCombinations(specifications);
    return skuList;
}

export const getExist = (selectSpecList, row) => {
    let spec = (row.skuSpecifications.map(item => item.valueKey)).join('-');
    const idx = selectSpecList.findIndex(item => {
        let text = item.spec1 ? `${item.spec0}-${item.spec1}` : `${item.spec0}`;
        if (!item.skuSpecifications[1]) {
            spec = row.skuSpecifications[0].valueKey;
        } 
        if (text === spec) {
            return true;
        }
        return false;
    })
    return idx !== -1;
}

const publishEntranceMap = {
    'prodCenter': 0,
    'distributionGoods': 1,
    'supplierShop': 2
}

export const getPublishEntrance = (from) => {
    return publishEntranceMap[from] || 0
}